// extracted by mini-css-extract-plugin
module.exports = {"root":"tenant-cohorts-page_root__Y2Yvg","items":"tenant-cohorts-page_items__3U8xy","title":"tenant-cohorts-page_title__23tCt"};